/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  InAppMessage,
  InAppMessageDeleteArgs,
  InAppMessagesArgs,
  notificationsApi,
} from '../services';

interface InAppMessagesState {
  isFetched: boolean;
  inAppMessages: InAppMessage[];
  page: number;
  hasNextPage: boolean;
}

const initialState: InAppMessagesState = {
  isFetched: false,
  inAppMessages: [],
  page: 0,
  hasNextPage: false,
};

const getInAppMessagesHandler = async (args: InAppMessagesArgs, { dispatch }: any) => {
  return dispatch(notificationsApi.endpoints.inAppMessages.initiate({ ...args })).unwrap();
};

export const getInAppMessages = createAsyncThunk('getInAppMessages', getInAppMessagesHandler);

export const loadMoreInAppMessages = createAsyncThunk(
  'getInAppMessages/loadMore',
  getInAppMessagesHandler
);

export const deleteInAppMessage = createAsyncThunk(
  'deleteInAppMessage',
  async (args: InAppMessageDeleteArgs, { dispatch }) => {
    const deleted = await dispatch(
      notificationsApi.endpoints.inAppMessageDelete.initiate(args)
    ).unwrap();
    return { ...args, deleted };
  }
);

const InAppMessagesSlice = createSlice({
  name: 'inAppMessages',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInAppMessages.pending, (state) => {
        state.isFetched = false;
      })
      .addCase(getInAppMessages.fulfilled, (state, action) => {
        const { items, pageInfo } = action.payload;
        const { page, hasNextPage } = pageInfo;

        state.isFetched = true;
        state.inAppMessages = items;
        state.page = page;
        state.hasNextPage = hasNextPage;
      })
      .addCase(loadMoreInAppMessages.fulfilled, (state, action) => {
        const { items, pageInfo } = action.payload;
        const { page, hasNextPage } = pageInfo;

        state.inAppMessages.push(...items);
        state.page = page;
        state.hasNextPage = hasNextPage;
      })
      .addCase(deleteInAppMessage.fulfilled, (state, action) => {
        const { deleted, inAppMessageId } = action.payload;

        if (!deleted) {
          return;
        }

        state.inAppMessages = state.inAppMessages.filter(({ id }) => id !== inAppMessageId);
      });
  },
});

export default InAppMessagesSlice.reducer;
